import {type AvmSpecSegment, SEGMENT} from "@reva/shared/reva-spec";

/**
 * Gibt es für dieses Segment überhaupt eine PDF-Ausgabe?
 *
 * Ausschließlich eine Segment-Frage — WHG_M (Wohnung Miete) hat keine PDF-Vorlage. Ob der
 * jeweilige Nutzer ein PDF anfordern darf, entscheiden davon unabhängig die Dokument- und
 * Lifecycle-Permissions (siehe `useAllowedArchiveDocumentTypes` und `PERMISSION_RULE_*`).
 *
 * Bewusst ohne Nutzer-/Rollenparameter: GRST_K (unbebautes Grundstück) war in #19207 kurzzeitig
 * auf Admins beschränkt (ad978731), was mit 4dfce18d wieder zurückgenommen wurde. Ein erneutes
 * Gate müsste die Signatur hier ändern und würde damit an den Tests auffallen.
 *
 * @param segment aktuell gewähltes Segment; solange die Bewertung noch lädt, undefined
 * @returns true, wenn für das Segment PDFs erzeugt werden können
 */
export function isPdfSupported(segment: AvmSpecSegment | null | undefined): boolean {
    return segment !== SEGMENT.WHG_M;
}
